export function isDeployedCode() {
  // @ts-ignore
  return !!process.env.PM2_PROCESS;
}

// i18n certified - complete
